export default __webpack_public_path__ + "static/wf_banner3-745dad4e56ad06b9d6b850c7c1ea2cd1.png";